export const ErrorListDialog = "ErrorListDialog";
export const ErrorListDialogErrorList = `${ErrorListDialog}__ErrorList`;
export const ErrorListDialogErrorName = `${ErrorListDialogErrorList}__Name`;
export const ErrorListDialogErrorDetails = `${ErrorListDialogErrorList}__Details`;